export default __webpack_public_path__ + "static/media/car-4.b75a8e20.png";